import { MomentDatePicker } from '@gravitate-js/excalibrr'
import type { GridApi, ICellEditorParams } from 'ag-grid-community'
import moment from 'moment'
import type React from 'react'
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'

type DateCellEditorProps = ICellEditorParams & {
  api: GridApi
  value: Date
  disabledDate?: (currentDate: moment.Moment) => boolean
  accessor?: string
}
export const DateCellEditor: React.FC<DateCellEditorProps> = forwardRef((props, ref) => {
  const primaryKey = props.colDef.field || props.colDef.colId
  const refInput = useRef(null)
  const [selectedDate, setSelectedDate] = useState(null)
  useEffect(() => {
    // focus on the input
    refInput.current.focus()
  }, [])

  const [date, setDate] = useState(null)
  const [editing, setEditing] = useState(true)

  useEffect(() => {
    if (!editing) {
      props.api.stopEditing()
    }
  }, [editing])

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return selectedDate.startOf('day')
      },
      isCancelBeforeStart() {
        return false
      },
      isCancelAfterEnd() {
        return (
          typeof selectedDate === 'undefined' ||
          selectedDate === null ||
          selectedDate?.isSame(moment(props?.data?.[props.accessor || primaryKey]))
        )
      },
    }
  })

  const onChange = (selectedDate) => {
    setDate(selectedDate)
    setSelectedDate(selectedDate)
    setEditing(false)
  }

  // @ts-ignore -- weird antd DatePicker return type issue here.
  return (
    <MomentDatePicker ref={refInput} onChange={onChange} value={date ?? undefined} disabledDate={props.disabledDate} />
  )
})
